module.exports = __webpack_public_path__ + "static/media/comment-alt-times.84e75850.svg";